import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import cx from 'classnames';
import * as absencesActions from '../../../store/portal';
import { Modal, Button } from 'react-bootstrap'
import ParentStyle from '../../../styles/parent-dashboard.module.scss';
import { sendStudentNote } from '../../../store/portal';
import * as moment from 'moment-timezone';
import { utilService } from '../../../common/utils';

class NotesPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formValues: {
        note: '',
        email_self: '',
        email_hrt: '',
        email_hoy: '',
        email_wellbeing_group: false,
        email_counsellor_staff: false,
        email_class_teachers: false,
        email_recipients: [],
        is_recipients: false,
        visible_all: false,
        noteType: 'General',
        created_by: this.props.user.username,
        student_userid: this.props.studentInfo.studentUid,
        student_username: this.props.studentInfo.username,
        head_of_year: '',
        homeroom_teacher: '',
        student: this.props.studentInfo.student,
      },
      error: { note: '' },
      is_error: '',
      isSaveNotes: false,
    };
    this.handleStudentNotesData()
  }

  handleStudentNotesData() {
    const studentUid = this.props.studentInfo.studentUid;
    const createdBy = this.props.user.username;

    if (this.props.studentInfo !== undefined) {
      this.props.getStudentNotes({
        token: this.props.token,
        params: `?student_userid=${studentUid}&created_by=${createdBy}&is_csv_export=True`
      });
    }
  }

  componentDidMount() {
    this.handleStudentNotesData()
  }

  addRecipient(e) {
    let flag = false
    let pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
    let email_list = e.target.value.split(',').map(function (value) {
      return value.trim();
    });
    for (var i = 0; i < email_list.length; i++) {
      flag = !pattern.test(email_list[i]) && email_list[i];
    }
    if (!flag) {
      this.setState({
        formValues: {
          ...this.state.formValues,
          email_recipients: email_list,
        }
      })
    }
    this.setState({ is_error: flag })
  }

  setFormValues(flag, e, name) {
    const email = this.props.user.email;
    if (flag === 'note') {
      this.setState({
        formValues: { ...this.state.formValues, [flag]: e.target.value },
        error: { ...this.state.error, note: '' },
      });
    } else if (flag === 'email_hrt') {
      this.setState({
        formValues: {
          ...this.state.formValues,
          homeroom_teacher: e.target.checked
            ? this.props.studentInfo.homeroom_teacher
            : '',
          email_hrt: e.target.checked
            ? e.target.value
            : '',
        },
      });
    } else if (flag === 'email_hoy') {
      this.setState({
        formValues: {
          ...this.state.formValues,
          head_of_year: e.target.checked
            ? this.props.studentInfo.head_of_year
            : '',
          email_hoy: e.target.checked ? e.target.value
            : '',
        },
      });
    } else if (flag === 'email_self') {
      this.setState({
        formValues: {
          ...this.state.formValues,
          email_self: e.target.checked ? e.target.value : ""
        }
      })
    } else if (flag == 'email_wellbeing_group') {
      this.setState({
        formValues: {
          ...this.state.formValues,
          email_wellbeing_group: e.target.checked
        }
      })
    } else if (flag == 'email_counsellor_staff') {
      this.setState({
        formValues: {
          ...this.state.formValues,
          email_counsellor_staff: e.target.checked
        }
      })
    } else if (flag == 'email_class_teachers') {
      this.setState({
        formValues: {
          ...this.state.formValues,
          email_class_teachers: e.target.checked
        }
      })
    } else if (flag == 'visible_all') {
      this.setState({
        formValues: {
          ...this.state.formValues,
          visible_all: e.target.checked
        }
      })
    } else if (flag == 'email_recipients') {
      this.setState({
        formValues: {
          ...this.state.formValues,
          is_recipients: e.target.checked,
          email_recipients: !e.target.checked && [],
        },
      })
    }
  }

  handleDownloadReport(data) {
    const fetchNotesInterval = setInterval(() => {
      if (!this.props.fetchStudentNotesLoading) {
        clearInterval(fetchNotesInterval);
        const url = data.pre_signed_URL;
        const anchor = document.createElement('a');
        anchor.setAttribute('href', url);
        anchor.setAttribute('download', this.props.studentInfo.username + '.csv');
        anchor.click();
        anchor.remove();
      }
    }, 100);
  }

  handleSubmit(e) {
    e.preventDefault();
    const formElement = e.currentTarget;
    if (this.state.formValues.note === '') {
      this.setState({
        error: { ...this.state.error, note: 'Required' },
      });
    }
    else if (this.state.formValues.is_recipients && this.state.is_error !== false) {
      let error;
    }
    else {
      const objToSend = {
        notesData: this.state.formValues,
        sortData: [],
      };
      this.props.appendStudentArray(this.state.formValues);
      this.props.sendStudentNote({
        token: this.props.token,
        data: objToSend
      });

      const sendNotesInterval = setInterval(() => {
        if (!this.props.sendStudentNotesLoading) {
          clearInterval(sendNotesInterval);
          formElement.reset();
          this.handleStudentNotesData();
          const fetchNotesInterval = setInterval(() => {
            if (!this.props.fetchStudentNotesLoading) {
              clearInterval(fetchNotesInterval);
              this.setState({
                isSaveNotes: true
              });
              setTimeout(() => {
                this.setState({
                  isSaveNotes: false,
                });
              }, 5000);
            }
          }, 100)
        }
      }, 100)
    }
  }

  render() {
    return this.props.showNotes ? (
      <>
        <div className="fade modal-backdrop show"></div>
        <div className={`modal ${ParentStyle.modalShow}`}>
          <Modal.Dialog
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Header>
              <Modal.Title>
                <span className={ParentStyle.headerFont}
                  dangerouslySetInnerHTML={{
                    __html: utilService.htmlDecode('Create new note for ' + this.props.studentInfo.student),
                  }}
                >

                </span>
              </Modal.Title>
              <button
                type="button"
                className="close"
                onClick={() => this.props.handleNotes(false)}
              >
                <span aria-hidden="true">×</span>
                <span className="sr-only">Close</span>
              </button>
            </Modal.Header>

            <Modal.Body>
              <form onSubmit={(e) => this.handleSubmit(e)}>
                <div className="current-notes d-flex">
                  <div className={ParentStyle.checkbox}>
                    Note type: {' '}
                    <select
                      style={{ width: "200px", height: "20px" }}
                      onChange={(e) => this.setState(
                        {
                          formValues: { ...this.state.formValues, noteType: e.target.value }
                        })}
                      value={this.state.formValues.noteType || ''}
                    >
                      <option value="General">General</option>
                      <option value="Uniform">Uniform</option>
                      <option value="Behaviour">Behaviour</option>
                    </select>
                    <div className={`d-flex`}>
                      <input
                        type="checkbox"
                        name="hrt"
                        id="homeroom"
                        className={ParentStyle.leftCheckbox}
                        value={this.props.studentInfo.homeroom_teacher_email}
                        onChange={(e) => this.setFormValues('email_hrt', e)}
                      />
                      <label className={ParentStyle.smallText} htmlFor="homeroom">
                        Email to Morning Connection Coach
                      </label>
                    </div>
                    <div className={`d-flex`}>
                      <input
                        type="checkbox"
                        name="hoy"
                        id="head"
                        className={ParentStyle.leftCheckbox}
                        value={this.props.studentInfo.head_of_year_email}
                        onChange={(e) => this.setFormValues('email_hoy', e)}
                      />
                      <label className={ParentStyle.smallText} htmlFor="head">Email to Head of Year</label>
                    </div>
                    <div className={`d-flex`}>
                      <input
                        type="checkbox"
                        name="self"
                        id="myself"
                        className={ParentStyle.leftCheckbox}
                        value={this.props.user.email}
                        onChange={(e) => this.setFormValues('email_self', e)}
                      />
                      <label className={ParentStyle.smallText} htmlFor="myself">Email to myself</label>
                    </div>
                    <div className={`d-flex`}>
                      <input
                        type="checkbox"
                        name="wellbeing_leadership"
                        id="wellbeing_leadership"
                        className={ParentStyle.leftCheckbox}
                        value="true"
                        onChange={(e) => this.setFormValues('email_wellbeing_group', e)}
                      />
                      <label className={ParentStyle.smallText} htmlFor="wellbeing_leadership">Email "Wellbeing Leadership" Group
                        {/* {this.props.studentInfo.homeroom_teacher_email && this.props.studentInfo.head_of_year_email ? (
                          "(" + this.props.studentInfo.homeroom_teacher_email.slice(0, 2).toUpperCase() + " & " + this.props.studentInfo.head_of_year_email.slice(0, 2).toUpperCase() + ")")
                          : this.props.studentInfo.homeroom_teacher_email ? ("(" + this.props.studentInfo.homeroom_teacher_email.slice(0, 2).toUpperCase() + ")")
                            : this.props.studentInfo.head_of_year_email ? ("(" + this.props.studentInfo.head_of_year_email.slice(0, 2).toUpperCase() + ")") : ''
                        } */}
                      </label>
                    </div>
                    <div className={`d-flex`}>
                      <input
                        type="checkbox"
                        name="consellor_staff"
                        id="consellor_staff"
                        className={ParentStyle.leftCheckbox}
                        value=""
                        onChange={(e) => this.setFormValues('email_counsellor_staff', e)}
                      />
                      <label className={ParentStyle.smallText} htmlFor="consellor_staff">Email “Counsellor Staff” Group</label>
                    </div>
                    <div className={`d-flex`}>
                      <input
                        type="checkbox"
                        name="current_teacher"
                        id="current_teacher"
                        className={ParentStyle.leftCheckbox}
                        value=""
                        onChange={(e) => this.setFormValues('email_class_teachers', e)}
                      />
                      <label className={ParentStyle.smallText} htmlFor="current_teacher">Email all {this.props.studentInfo.student.split(',')[1]}'s current teachers</label>
                    </div>
                    <div className={`d-flex`}>
                      <input
                        type="checkbox"
                        name="visible_all"
                        id="visible_all"
                        className={ParentStyle.leftCheckbox}
                        value=""
                        onChange={(e) => this.setFormValues('visible_all', e)}
                      />
                      <label className={ParentStyle.smallText} htmlFor="visible_all">Make this note visible to all teachers</label>
                    </div>
                  </div>
                  <div className="notes-area">
                    <textarea
                      type="text"
                      name="notes"
                      className={ParentStyle.textArea}
                      onChange={(e) => this.setFormValues('note', e)}
                    />
                    {this.state.error.note === 'Required' ? (
                      <span className={ParentStyle.textDanger}>Required</span>
                    ) : (
                      ''
                    )}
                    <div className={cx(ParentStyle.textDanger, 'text-right')}>
                      Notes cannot be edited once saved and sent
                    </div>
                    <div className="text-right">
                      <Button
                        type="submit"
                        variant="secondary"
                        className={ParentStyle.saveButton}
                        disabled={this.props.sendStudentNotesLoading}
                      >
                        SAVE & SEND
                      </Button>
                    </div>
                  </div>
                </div>
                <div className="d-flex mr-6">
                  <div className="d-flex flex-shrink-0 mr-3">
                    <input
                      type="checkbox"
                      name="email_recipients"
                      id="email_recipients"
                      className={ParentStyle.leftCheckbox}
                      value=""
                      onChange={(e) => this.setFormValues('email_recipients', e)}
                    />
                    <label className={ParentStyle.smallText} htmlFor="email_recipients">Add email recipient/s(Comma Separated)</label>
                  </div>
                  {this.state.formValues.is_recipients &&
                    <div className="flex-grow-1">
                      <input type="text"
                        onChange={(e) => this.addRecipient(e)}
                        placeholder="teacher@plc.nsw.edu.au, teacher2@plc.nsw.edu.au, teacher3@plc.nsw.edu.au"
                        readOnly={!this.state.formValues.is_recipients}
                        className="w-100"
                      />
                      {this.state.is_error && <span className={cx(ParentStyle.textDanger, 'd-block')}>Please enter valid email </span>}
                    </div>}
                </div>

              </form>
              {this.state.isSaveNotes && <div className={ParentStyle.notesMessage}>Message sent/saved successfully!</div>}
              <div className={ParentStyle.previousNotes}>
                <Modal.Body className={cx(ParentStyle.modalHeader, 'd-flex align-items-center')}>
                  <span className={ParentStyle.headerFont}>Previous notes</span>
                  {this.props.parentDashboard.studentNotes.notes[0] && this.props.parentDashboard.studentNotes.notes[0].records.is_download_notes &&
                    <div className="ml-auto">
                      <button
                        className="btn btn-pear d-flex align-items-center p-3"
                        onClick={() =>
                          this.handleDownloadReport(
                            this.props.parentDashboard.studentNotes.notes[0].records
                          )
                        }
                        disabled={Object.keys(this.props.parentDashboard.studentNotes.notes).length > 0 ? this.props.parentDashboard.studentNotes.notes[0].records.notes.length > 0 ? false : true : true}
                      >
                        <span className="mr-2">
                          Download all notes to CSV
                        </span>
                        <img
                          className={cx(ParentStyle.downloadImg, 'flex-shrink-0')}
                          src={'/assets/img/ic_download.png'}
                        />
                      </button>
                    </div>
                  }
                </Modal.Body>
                {this.props.parentDashboard.studentNotes.notes[0] !== undefined
                  ? this.props.parentDashboard.studentNotes.notes[0].records.notes.map(
                    (value, index) => (
                      <>
                        <div className={`d-flex`}>
                          <span className={ParentStyle.textDangerBold}>
                            Note Type: {value.type}
                          </span>
                        </div>
                        <div className={`previous-notes d-flex ${ParentStyle.notesItemList}`} key={index}>
                          <div className={ParentStyle.checkbox}>
                            <div className={`d-flex`}>
                              <input
                                type="checkbox"
                                name="homeroom-teacher"
                                id="previous-homeroom"
                                className={ParentStyle.innerCheckbox}
                                checked={value.email_hrt != '' ? true : false}
                                disabled
                              />
                              <label className={ParentStyle.smallText} htmlFor="previous-homeroom">
                                Homeroom teacher
                              </label>
                            </div>
                            <div className={`d-flex`}>
                              <input
                                type="checkbox"
                                name="head-of-year"
                                id="previous-head"
                                className={ParentStyle.innerCheckbox}
                                checked={value.email_hoy != '' ? true : false}
                                disabled
                              />
                              <label className={ParentStyle.smallText} htmlFor="previous-head">
                                Head of Year
                              </label>
                            </div>
                            <div className={`d-flex`}>
                              <input
                                type="checkbox"
                                name="myself"
                                id="previous-myself"
                                className={ParentStyle.innerCheckbox}
                                checked={value.email_self != '' ? true : false}
                                disabled
                              />
                              <label className={ParentStyle.smallText} htmlFor="previous-myself">Myself</label>
                            </div>
                            <div className={`d-flex`}>
                              <input
                                type="checkbox"
                                name="myself"
                                id="previous-myself"
                                className={ParentStyle.innerCheckbox}
                                checked={value.email_wellbeing_group != '' ? true : false}
                                disabled
                              />
                              <label className={ParentStyle.smallText} htmlFor="wellbeing_leadership">Email "Wellbeing Leadership" Group(L Chiba & M Halkidis)
                                {/* {this.props.studentInfo.homeroom_teacher_email && this.props.studentInfo.head_of_year_email ? (
                                  "(" + this.props.studentInfo.homeroom_teacher_email.slice(0, 2).toUpperCase() + " & " + this.props.studentInfo.head_of_year_email.slice(0, 2).toUpperCase() + ")")
                                  : this.props.studentInfo.homeroom_teacher_email ? ("(" + this.props.studentInfo.homeroom_teacher_email.slice(0, 2).toUpperCase() + ")")
                                    : this.props.studentInfo.head_of_year_email ? ("(" + this.props.studentInfo.head_of_year_email.slice(0, 2).toUpperCase() + ")") : ''
                                } */}
                              </label>
                            </div>
                            <div className={`d-flex`}>
                              <input
                                type="checkbox"
                                name="myself"
                                id="previous-myself"
                                className={ParentStyle.innerCheckbox}
                                checked={value.email_counsellor_staff != '' ? true : false}
                                disabled
                              />
                              <label className={ParentStyle.smallText} htmlFor="previous-myself">Email “Counsellor Staff” Group(Breanna)</label>
                            </div>
                            <div className={`d-flex`}>
                              <input
                                type="checkbox"
                                name="myself"
                                id="previous-myself"
                                className={ParentStyle.innerCheckbox}
                                checked={value.email_class_teachers != '' ? true : false}
                                disabled
                              />
                              <label className={ParentStyle.smallText} htmlFor="previous-myself">Email all {this.props.studentInfo.student.split(',')[1]}'s current teachers</label>
                            </div>
                            <div className={`d-flex`}>
                              <input
                                type="checkbox"
                                name="myself"
                                id="previous-myself"
                                className={ParentStyle.innerCheckbox}
                                checked={value.visible_all != '' ? true : false}
                                disabled
                              />
                              <label className={ParentStyle.smallText} htmlFor="previous-myself">Make this note visible to all teachers</label>
                            </div>
                            <div className="d-flex mr-6">
                              <div className="d-flex flex-shrink-0 mr-3">
                                <input
                                  type="checkbox"
                                  name="myself"
                                  id="previous-myself"
                                  checked={value.email_recipients && value.email_recipients.length > 0 ? true : false}
                                  className={ParentStyle.innerCheckbox}
                                  disabled
                                />
                                <label className={ParentStyle.smallText} htmlFor="previous-myself">Add email recipient/s</label>
                                <div className="flex-grow-1" style={{ 'margin-left': '106px' }}>
                                  {value.email_recipients && value.email_recipients.map(function (item, index) {
                                    return <span className={ParentStyle.smallText} style={{ color: 'gray' }} key={`${index}`}>{(index ? ', ' : '') + item}</span>;
                                  })}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="notes-area">
                            <textarea
                              type="text"
                              name="notes"
                              className={ParentStyle.textArea}
                              value={value.note}
                              disabled
                            />
                            <div data-time={value.created_date}
                              style={{ 'fontSize': '14px ' }}>Submitted by : {value.created_by} {' '}
                              {moment(value.created_date.replace('Z', '')).format('DD-MM-YYYY h:mm A')}
                            </div>
                          </div>
                        </div>
                      </>
                    )
                  )
                  : ''}
              </div>
            </Modal.Body>
          </Modal.Dialog>
        </div>
      </>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    parentDashboardActionLoading: state.parentDashboard.actionsloading,
    fetchStudentNotesLoading: state.parentDashboard.fetchStudentNotesLoading,
    sendStudentNotesLoading: state.parentDashboard.sendStudentNotesLoading,
    token: state.user.cognito_data.token,
    parentDashboard: state.parentDashboard,
    user: state.user.user,
  };
}

export default connect(mapStateToProps, (dispatch) =>
  bindActionCreators(Object.assign({}, absencesActions), dispatch)
)(NotesPopup);